import { generateAIChairScript } from './aiChairScript';
import { getQuorumStatus } from './quorumUtils';

/**
 * Context-aware lines the chair can insert as an ad hoc activity / minutes note.
 */
export function buildChairNoteSuggestions(meetingState, motionTypesMap = {}) {
  const quorumStatus = meetingState.quorumStatus || getQuorumStatus(meetingState.meetingSetup || {});
  const state = {
    ...meetingState,
    quorumStatus,
    isQuorumPresent: meetingState.isQuorumPresent ?? quorumStatus.present,
  };

  let smart = '';
  try {
    smart = (generateAIChairScript(state) || '').trim();
  } catch {
    smart = '';
  }

  const suggestions = [];
  if (smart) suggestions.push(smart);

  const { currentMotion, pendingUCRequest, currentSpeaker } = state;

  if (!quorumStatus.present) {
    suggestions.push(
      'The chair notes that a quorum is not present. No binding action may be taken until a quorum is established.'
    );
  }

  if (pendingUCRequest?.text) {
    suggestions.push(
      `The chair notes a pending request for unanimous consent: "${pendingUCRequest.text}".`
    );
  }

  if (currentSpeaker) {
    suggestions.push(
      'The chair reminds members that remarks should be addressed through the chair and kept germane to the pending question.'
    );
  }

  if (currentMotion && motionTypesMap[currentMotion.type]) {
    const name = motionTypesMap[currentMotion.type].name;
    const quote =
      currentMotion.text && currentMotion.text !== name ? ` “${currentMotion.text}”` : '';
    suggestions.push(`The chair notes that the pending question is ${name.toLowerCase()}${quote}.`);
  }

  suggestions.push('The chair reminds the assembly that only one main motion may be pending at a time.');
  suggestions.push('For the record: ');

  const seen = new Set();
  return suggestions.filter((line) => {
    const k = line.trim();
    if (!k || seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
